// extracted by mini-css-extract-plugin
export var resumeStyle = "resume-module--resumeStyle--1CoY1";
export var heading = "resume-module--heading--2FRdI";
export var contact_detail = "resume-module--contact_detail--1eZqg";
export var profile = "resume-module--profile--EPFGz";
export var item = "resume-module--item--1jFCJ";
export var item_position = "resume-module--item_position--3bvRl";
export var item_dates = "resume-module--item_dates--bsASf";
export var item_highlights = "resume-module--item_highlights--3pYgh";
export var skills = "resume-module--skills--EEKVy";
export var skills_item = "resume-module--skills_item--iBZjq";
export var skills_item_name = "resume-module--skills_item_name--BRPMR";
export var skills_item_keywords = "resume-module--skills_item_keywords--2Le1r";
export var education = "resume-module--education--2hmQ2";